import { error } from 'util';
import * as angular from 'angular';
import { HttpService } from '../../../../app.common/modules/api/http.service';
import { RetailerService } from '../../api/retailer.service';
import { IIngredient } from '../../model/ingredients/IIngredient';
import { IIngredientSearchFilter } from '../../model/ingredients/IIngredientSearchFilter';
import { IPagingResult } from '../../model/IPagingResult.model';

export class IngredientsService {
    public static $inject = ['http', 'retailerService', '$localStorage', '$uibModal', '$timeout' ];

    constructor(
        private http: HttpService,
        private retailerService: RetailerService,
    ) { }

    public getIngredients(filter: IIngredientSearchFilter) {
        return this.http.get<IPagingResult<IIngredient>>(this.retailerService.getIngredients(), { params: filter });
    }

    public getIngredient(id: string) {
        return this.http.get<IIngredient>(this.retailerService.getIngredient(id));
    }

    public addIngredient(ingredientTitle: string) {
        return this.http.post(this.retailerService.getIngredients(), { Title: ingredientTitle });
    }

    public checkTitleForExist(ingredientTitle: string, ingredientID?: string) {
        return this.http.get(this.retailerService.getCheckIngredients(), { params: { title: ingredientTitle, ingredientID } });
    }

    public editIngredient(id: string, ingredientTitle: string) {
        return this.http.put(this.retailerService.getIngredient(id), { Title: ingredientTitle });
    }

    public archiveIngredient(id: string) {
        return this.http.put(this.retailerService.archiveIngredient(id), null);
    }

    public restoreIngredient(id: string) {
        return this.http.put(this.retailerService.restoreIngredient(id), null);
    }
}

angular
    .module('naut')
    .service('ingredientsService', IngredientsService);



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/common/services/ingredients.service.ts